//
//  useCsvDownload.tsx
//
//  isana.net,inc. Proprietary and Confidential
//

import { useCallback, useState } from "react";
import { downloadCustomCsv } from "../network/api";
import { CsvDownloader } from "../network/type";

// downloader差し替えでGHA CSV等の別エンドポイントにも対応する（省略時は従来どおり）
export const useCsvDownload = (
  downloader: CsvDownloader = downloadCustomCsv
) => {
  const [isDownloading, setIsDownloading] = useState<boolean>(false);

  const handleCsvDownload = useCallback(
    async (fileName: string) => {
      setIsDownloading(true);
      try {
        const response = await downloader(fileName);
        if (response.status === 404) {
          return;
        }
        if (response.status >= 200 && response.status < 300) {
          const { url } = response.data;
          if (url && typeof url === "string") {
            window.location.href = url;
          }
        }
      } finally {
        setIsDownloading(false);
      }
    },
    [downloader]
  );

  return { handleCsvDownload, isDownloading };
};
